import { RELATIVE_DATE_LIST } from './relativeDatesList';
import { SfdcDisplayType } from '../../../../types/fields';

export const getRelativeDateList = (sfDisplayType?: SfdcDisplayType) => {
  if (sfDisplayType === SfdcDisplayType.DATE) {
    return RELATIVE_DATE_LIST.Date;
  }
  return RELATIVE_DATE_LIST.DateTime;
};
